import React from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchDictionary,
  updateDictionary,
  createDictionaryItem,
} from "../Actions";
import AdditionalCompetenciesDictionary from "../Components/AdditionalCompetenciesDictionary";
import validate from "../../Persons/Validators/CompetenciesValidator";

const FORM_NAME = `DICTIONARY_ADDITIONAL_COMPETENCIES`;

let AdditionalCompetenciesForm = props => (
  <AdditionalCompetenciesDictionary {...props} />
);

const selector = formValueSelector(FORM_NAME);

function mapStateToProps(state) {
  const values = selector(state, "employeeCompetencies");
  let {
    dictionaries: { employeeCompetencies },
  } = state;
  return {
    values,
    initialValues: { employeeCompetencies },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchDictionary,
      updateDictionary,
      createDictionaryItem,
    },
    dispatch,
  );
}

export default reduxForm({
  form: FORM_NAME,
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AdditionalCompetenciesForm),
);
